// extracted by mini-css-extract-plugin
export default {"root":"CreateClientHeader_root__dllZN","title":"CreateClientHeader_title__wsixK"};